import "core-js/modules/es.json.stringify.js";
import { Encrypt } from '@/views/miniGame/encrypt_game';
import auth from '@/utils/auth';
var state = {
  openId: auth.lsGetOpenId() || null,
  gameToken: auth.lsGetGameToken() || null,
  // 游戏token
  skillList: auth.lsGetSkillList() || [],
  // 技能卡列表
  checkedSkill: auth.lsGetCheckedSkill() || {
    engine: null,
    spaceship: null
  } // 已装备的技能列表 引擎-engine;飞船-spaceship
};
var mutations = {
  SET_OPEN_ID: function SET_OPEN_ID(state, data) {
    auth.lsSetOpenId(data);
    state.openId = data;
  },
  SET_GAME_TOKEN: function SET_GAME_TOKEN(state, data) {
    auth.lsSetGameToken(data);
    state.gameToken = data;
  },
  SET_SKILL_LIST: function SET_SKILL_LIST(state, data) {
    auth.lsSetSkillList(data);
    state.skillList = data;
  },
  SET_CHECKED_SKILL: function SET_CHECKED_SKILL(state, data) {
    auth.lsSetCheckedSkill(data);
    state.checkedSkill = data;
  }
};
var actions = {
  setOpenId: function setOpenId(_ref, payload) {
    var commit = _ref.commit;
    commit('SET_OPEN_ID', payload);
  },
  setGameToken: function setGameToken(_ref2, payload) {
    var commit = _ref2.commit;
    commit('SET_GAME_TOKEN', payload);
  },
  setSkillList: function setSkillList(_ref3, payload) {
    var commit = _ref3.commit;
    commit('SET_SKILL_LIST', payload);
  },
  setCheckedSkill: function setCheckedSkill(_ref4, payload) {
    var commit = _ref4.commit;
    commit('SET_CHECKED_SKILL', payload);
  }
};
var getters = {
  getSign: function getSign(state) {
    var signString = {
      userId: state.openId,
      timestamp: new Date().getTime()
    };
    return Encrypt(JSON.stringify(signString));
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};